import { InnoEcosystem, Nomad, School } from '@ice-web-app/assets';
import { useTranslation } from '@ice-web-app/shared-hooks';
import { useCurrentUserStore } from '@ice-web-app/shared-store';
import { UserEcosystemAPI } from '@ice-web-app/shared-types';
import { Stack } from '@mui/material';
import { Dispatch, FC, ReactElement, SetStateAction } from 'react';
import QuickLink from '../Links/QuickLink';
import MiniNavbarMenu from '../MiniNavbarMenu';

interface Props {
  anchorEl: HTMLElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
  setMenu: Dispatch<SetStateAction<'ecosystem' | 'microSystem' | 'member' | 'none'>>;
}

const EcosystemMenu: FC<Props> = ({ anchorEl, setAnchorEl, setMenu }) => {
  const { t } = useTranslation();
  const open = Boolean(anchorEl);
  const { currentUser, currentEcosystem, setCurrentEcosystem } = useCurrentUserStore();

  const renderEcosystemNameIcon = (ecosys: UserEcosystemAPI['ecosystem']) => {
    let ecosystemName = '';
    let ecosystemIcon: ReactElement;
    switch (ecosys) {
      case 'eco_innovation':
        ecosystemName = 'INNOVATION';
        ecosystemIcon = <InnoEcosystem />;
        break;
      case 'nomad':
        ecosystemName = 'NOMAD';
        ecosystemIcon = <Nomad />;
        break;
      case 'eco_school':
        ecosystemName = 'SCHOOL';
        ecosystemIcon = <School />;
        break;
      default:
        ecosystemName = 'INNOVATION';
        ecosystemIcon = <InnoEcosystem />;
    }
    return { ecosystemName, ecosystemIcon };
  };

  return (
    <MiniNavbarMenu
      anchorEl={anchorEl}
      open={open}
      onClose={() => {
        setTimeout(() => {
          setAnchorEl(null);
        }, 0);
        setMenu('none');
      }}
      setAnchorEl={setAnchorEl}
    >
      <Stack direction="row">
        {currentUser?.ecosystems?.map((item) => {
          return (
            <QuickLink
              key={item.ecosystem}
              icon={renderEcosystemNameIcon(item.ecosystem).ecosystemIcon}
              text={t(renderEcosystemNameIcon(item.ecosystem).ecosystemName)}
              width={92}
              isActive={item.ecosystem === currentEcosystem?.ecosystem}
              onClick={() => {
                setCurrentEcosystem(item);
                setMenu('microSystem');
              }}
            />
          );
        })}
      </Stack>
    </MiniNavbarMenu>
  );
};
export default EcosystemMenu;
